import { composePromise } from './functionalBob'

const service = (serviceFunc, context, ...args) => async data => {
  const res = await serviceFunc.call(context, data, ...args)
  if (!res) throw new Error('Service Failed')
  return res
}
const serviceNoError = (serviceFunc, context, ...args) => async data => {
  const res = await serviceFunc.call(context, data, ...args)
  return res
}
const mapper = (mapperFunc, context, ...args) => (...data) => {
  if (data.length === 1) return mapperFunc.call(context, data[0], ...args)
  else return mapperFunc.call(context, ...data, ...args)
}
const model = (Model, ...args) => (x) => new Model(x, ...args)

// To use the get composition:
//    get(<model>, <mapper>, <service>)(<data>)
//    compose the helper methods - model, mapper, service
//    model(<model definition>, <additional args to be passed into the model constructor>)
//      the first parameter applied to the model constructor is the data that is the result of the mapper function
//    mapper(<mapper function>, <mapper context>, <additional args to be passed into the mapper function>)
//      the second parameter applied to the mapper function is the data that is the result of the service function
//    service(<service function>, <service context>, <additional args to be passed into the service function>)
//      the third parameter applied to the service function is the data that is passed to the execution of get()
const get = (modelHelper, mapperHelper, serviceHelper) => composePromise(modelHelper, mapperHelper, serviceHelper)

// the post composition is the same as get, except it works in the reverse direction
// here you map some data (from some model / obj), and then pass that mapped data to a service to make a call
const post = (serviceHelper, mapperHelper) => composePromise(serviceHelper, mapperHelper)

export default { get, post, model, mapper, service, serviceNoError }
